import { render, staticRenderFns } from "./PosicionWrapper.vue?vue&type=template&id=5c0cbf4c&scoped=true&"
import script from "./PosicionWrapper.vue?vue&type=script&lang=js&"
export * from "./PosicionWrapper.vue?vue&type=script&lang=js&"
import style0 from "./PosicionWrapper.vue?vue&type=style&index=0&id=5c0cbf4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0cbf4c",
  null
  
)

export default component.exports